import { CompositeLayerProps, Filter } from '@Map/layers/types';
import type VectorTileLayer from '@arcgis/core/layers/VectorTileLayer';

import LayerBase, { Config, CompositeLike } from './LayerBase';

export default class HighlightBackgroundLayer extends LayerBase {
	private _highlightItems: string[] = [];

	constructor(
		layerInfo: CompositeLayerProps,
		vectorTileLayer?: VectorTileLayer,
		config: Config | undefined = undefined,
		composite?: CompositeLike,
	) {
		super(
			layerInfo,
			vectorTileLayer,
			config ?? {
				zIndexesPerType: { base: 2000, line: 2000, symbol: 2000 },
				selected: true,
				highlightBackground: true,
				idPostfix: '-highlight-background',
				composite,
			},
		);
	}

	get highlightedItems(): string[] {
		return this._highlightItems;
	}

	set highlightedItems(items: string[]) {
		this._highlightItems = items;
		// Keep LayerBase's own `filter` field in sync with the live
		// highlight state (not just the VTL live-patch below) - it's what
		// `CompositeLayer.styleLayerHighlighted` reconciles against when
		// EsriLayerManager rebuilds the full style. Without this, a style
		// rebuild reapplies whatever filter was frozen in at construction
		// time, silently resurrecting a stale (possibly non-empty) highlight.
		this.filter = this._getFilter();
	}

	protected _getFilter = (): Filter => {
		return [
			'in',
			'id',
			...(this.highlightedItems.length ? this.highlightedItems : ['']),
		];
	};
}
